import {h, Component} from 'preact'
import Masonry from 'react-masonry-component'

export default class AsideShapes extends Component {
    constructor() {
        super()
        this.state = {}
    }

    goToRoot() {
        this.setState({view: 'root'})
    }

    render(props, state) {
        return (
            <div id="app-aside-shapes" class="aside-text">
                <div class="scroller no-top">
                    <div class="to-root">
                        <a onClick={ () => props.goToRoot() }>
                            All graphics
                        </a>
                        <span class="path">&gt;&nbsp; Shapes</span>
                    </div>
                    <div class="components images">
                        <Masonry updateOnEachImageLoad={true} className={'masonry-grid'}>
                            <div class="component template" data-component="shape" data-shape="line">
                                <div class="image" data-component="shape" data-shape="line">
                                    <div class="svg-content">
                                        <svg width="95" height="95" viewBox="0 0 95 95">
                                            <line fill="none" stroke="#000000" stroke-width="5" x1="8" y1="5" x2="85" y2="85" fill-opacity="1" stroke-opacity="1"></line>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="component template" data-component="shape" data-shape="square">
                                <div class="image" data-component="shape" data-shape="square">
                                    <div class="svg-content">
                                        <svg width="100" height="100" viewBox="0 0 100 100">
                                            <rect fill="none" stroke="#000000" stroke-width="5" stroke-dasharray="null"
                                                  stroke-linejoin="null" stroke-linecap="null" x="6" y="6" width="86"
                                                  height="86" fill-opacity="1" stroke-opacity="1"></rect>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="component template" data-component="shape" data-shape="circle">
                                <div class="image" data-component="shape" data-shape="circle">
                                    <div class="svg-content">
                                        <svg width="100" height="100" viewBox="0 0 100 100">
                                            <ellipse fill="none" stroke="#000000" stroke-width="5" stroke-dasharray="null"
                                                 stroke-linejoin="null" stroke-linecap="null" cx="50" cy="50" rx="43" ry="43"
                                                 fill-opacity="1" stroke-opacity="1"></ellipse>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div class="component template" data-component="shape" data-shape="line">
                                <div class="image" data-component="shape" data-shape="line" data-shape-orientation="vertical" style="transform: rotate(1.5708rad)">
                                    <div class="svg-content">
                                        <svg width="95" height="95" viewBox="0 0 95 95">
                                            <line fill="none" stroke="#000000" stroke-width="5" x1="8" y1="85" x2="85" y2="85" fill-opacity="1" stroke-opacity="1"></line>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </Masonry>
                    </div>
                </div>
            </div>
        )
    }
}